"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var Localize_1 = require("../../gen-src/Localize");
exports.maxTagLength = 255;
var TagsEditorTestId = 'tags-editor';
/**
 * This component wraps the ChipPicker widget with functionality specific to editing tags on
 * Tableau Server content items. It does not include save/cancel logic (which can be provided,
 * depending on the UX situation, with a helper such as `ReactConfirmActionDialog` or `useInlineEditor`),
 * nor does it provide API connectivity to get/save the tags (this is also instantiation-specific).
 *
 * This is a controlled component, hence state must be managed by the parent. This component was
 * designed to work with the state management logic of either `ReactConfirmActionDialog` or `useInlineEditor`.
 * In common usage, the parent can simply store the state updates provided by `setEditorState` with
 * no additional processing (i.e. pass the updates directly to the dialog's state handler).
 *
 * @param props See documentation for TagsEditorProps
 */
function TagsEditor(props) {
    var _a;
    var onFilterItems = React.useCallback(function (value) { return props.setEditorState(function (prevState) { return (__assign(__assign({}, prevState), { partialText: value })); }); }, [props.setEditorState]);
    var onValueAdd = React.useCallback(function (value, index) {
        props.setEditorState(function (prevState) {
            if (prevState.tags.find(function (t) { return t === value; }) !== undefined) {
                return prevState;
            }
            else {
                var updated = __spreadArrays(prevState.tags);
                updated.splice(index, 0, value);
                return __assign(__assign({}, prevState), { tags: updated });
            }
        });
    }, [props.setEditorState]);
    var onValuesChange = React.useCallback(function (selectedValues) {
        props.setEditorState(function (prevState) { return (__assign(__assign({}, prevState), { tags: selectedValues })); });
    }, [props.setEditorState]);
    var onChangeCapture = React.useCallback(function (event) {
        var value = event.target.value;
        var clean = value.replace(/[",]/g, '');
        event.target.value = clean.length > exports.maxTagLength ? clean.slice(0, exports.maxTagLength) : clean;
    }, []);
    // Change handler for partialText. Calls the API to get the tag suggestions.
    React.useEffect(function () {
        var _a;
        var value = (_a = props.editorState.partialText) === null || _a === void 0 ? void 0 : _a.trim();
        if (!value) {
            props.setEditorState(function (prevState) { return (__assign(__assign({}, prevState), { suggestions: [] })); });
            return;
        }
        else {
            props.setEditorState(function (prevState) { return (__assign(__assign({}, prevState), { suggestions: [{ value: value, disabled: false }] })); });
        }
        // TODO: Use a state machine to mitigate possible race conditions
        props.searchMatchingTags(value).then(function (matchingTags) {
            var suggestions = suggestionsToListItems(value, matchingTags);
            props.setEditorState(function (prevState) { return (__assign(__assign({}, prevState), { suggestions: suggestions })); });
        }).catch(function (_) { return; });
    }, [props.editorState.partialText]);
    return (React.createElement(widgets_1.ChipPicker, { label: '', disabled: props.disableEditor, testId: TagsEditorTestId, listItems: props.editorState.suggestions, placeholder: Localize_1.Messages.AddATag(), onValueAdd: onValueAdd, onValuesChange: onValuesChange, onFilterItems: onFilterItems, onChangeCapture: onChangeCapture, style: { flex: '1 1 0%', marginTop: widgets_1.TabStyles.Spacing.DefaultSpace } }, (_a = props.editorState) === null || _a === void 0 ? void 0 : _a.tags.map(function (value) { return (React.createElement(widgets_1.Chip, { key: value, tooltip: value, value: value }, value)); })));
}
exports.TagsEditor = TagsEditor;
function suggestionsToListItems(search, suggestions) {
    var mapped = suggestions.map(function (t) { return ({ value: t, disabled: false }); });
    var match = mapped.findIndex(function (t) { return t.value === search; });
    if (match > -1) {
        mapped.splice(match, 1);
    }
    mapped.unshift({ value: search, disabled: false });
    return mapped;
}
/**
 * For most content items, we have separate APIs for adding and removing tags. This helper function
 * takes the diff between the old and the new tags lists to figure out which ones need to be added or removed.
 *
 * It also encloses each tag in an extra set of quotation marks, which is required for the API to properly
 * handle tags containing spaces.
 */
function getTagListsForVizportalApi(params) {
    var oldTags = params.oldTags, newTags = params.newTags;
    var tagsToAdd = newTags.filter(function (tag) { return oldTags.indexOf(tag) === -1; }).map(function (tag) { return "\"" + tag + "\""; });
    var tagsToRemove = oldTags.filter(function (tag) { return newTags.indexOf(tag) === -1; }).map(function (tag) { return "\"" + tag + "\""; });
    return { tagsToAdd: tagsToAdd, tagsToRemove: tagsToRemove };
}
exports.getTagListsForVizportalApi = getTagListsForVizportalApi;
//# sourceMappingURL=TagsEditor.js.map